export default "__VITE_ASSET__BI47PWLp__"